module.exports = require("core-js/modules/es.weak-set.js");